export default __webpack_public_path__ + "static/media/chat.3d972f35.svg";